module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-touch', {
    staticClass: "day-cal__overlay"
  }, [_c('div', {
    staticClass: "days-container",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('div', {
    staticClass: "day"
  }, [_c('day-cal', {
    attrs: {
      "locale": _vm.locale,
      "i18n": _vm.i18n,
      "date": _vm.date,
      "events": _vm.lessons,
      "viewState": _vm.viewState
    },
    on: {
      "eventClicked": _vm.onTap,
      "lessonsUpdate": _vm.setScrollTop
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-141e3622!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/DayCal/CalContainer.vue
// module id = 1773
// module chunks = 1